import { BrowserModule, Title }  from '@angular/platform-browser';
import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { HttpModule }     from '@angular/http';
import { MaterialModule } from '@angular/material';
import { RouterModule }   from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ApiService } from './api.service';
import { AppComponent } from './app.component';
import { BodyComponent } from './body.component';
import { FormComponent } from './form/form.component';
import { SpecialClientComponent } from './special-client/special-client.component';
import { C16Component } from './client/c16/c16.component';
import { C12Component } from './client/c12/c12.component';
import { FontfamilyDirective } from './fontfamily.directive';

@NgModule({
  declarations: [
    BodyComponent,
    AppComponent,
    FormComponent,
    SpecialClientComponent,
    C16Component,
    C12Component,
    FontfamilyDirective,
  ],
  entryComponents: [
    C16Component,
    C12Component
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    CommonModule,
    MaterialModule.forRoot(),
    RouterModule.forRoot([
      {
        path: '',
        component: FormComponent
      }
    ])
  ],
  providers: [
    ApiService,
    Title
  ],
  bootstrap: [BodyComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts